import { ActionTree } from "vuex";
import {
  RootState,
  ReservationState,
  StandRes,
  Reservation
} from "../../interface";
import {
  loadReservationDataAction,
  loadReservationReviewAction,
  submitReservationAction,
  removePayFailReservationAction
} from "./action-types";
import {
  updateReservationState,
  updateReviewData,
  updatePendingReservation
} from "./mutation-types";
import { loadHomeDataAction } from "../home/action-types";
import { courseInfoGetter, reservationGetter } from "../home/getter-types";
import {
  getStartDateRange,
  getStartDate,
  reservationFullTime
} from "@/helper/reservationHelper";
import { isSystemCourseGetter } from "./getter-types";
import {
  toLocalDateTimeString,
  toDateObject,
  formatLocalDateTime,
  toDateISOString
} from "@/utils/util";
import { loadCourseDetailAction } from "../courseDetail/action-types";
import { courseDetailGetter } from "../courseDetail/getter-types";
import { HttpClient } from "@/service/httpClient";
import { refreshTokenAction } from "../user/action-types";

export const actions: ActionTree<ReservationState, RootState> = {
  [loadReservationDataAction]: (
    { dispatch, commit, rootGetters },
    { id, type }
  ) => {
    return dispatch("home/" + loadHomeDataAction, null, { root: true }).then(
      () => {
        const reservation = rootGetters["home/" + reservationGetter](id);
        if (reservation) {
          throw "course already reserved";
        }
        const data = rootGetters["home/" + courseInfoGetter](id, type);
        if (data) {
          const startDate = getStartDate(data.openDate);
          const firstDateDateRange = getStartDateRange(startDate);
          const firstDate = {
            value: firstDateDateRange[0].key,
            options: firstDateDateRange
          };

          startDate.setHours(8, 0, 0);
          const endDate =
            firstDateDateRange[firstDateDateRange.length - 1].rawDate;
          endDate.setHours(22, 0, 0);
          return reservationFullTime(
            id,
            startDate.getTime(),
            endDate.getTime()
          ).then(fullTimeMap => {
            return commit(updateReservationState, {
              courseInfo: data,
              formData: {
                firstDate,
                fullTimeMap,
                diabledTimes: fullTimeMap[firstDate.value] || []
              }
            });
          });
        } else {
          throw "course not exist";
        }
      }
    );
  },
  [loadReservationReviewAction]: ({
    dispatch,
    commit,
    getters,
    rootGetters,
    state
  }) => {
    const courseInfo = state.courseInfo;
    const formResults = state.formResults;
    if (!courseInfo || !formResults) {
      return Promise.resolve();
    }
    if (getters[isSystemCourseGetter]) {
      const courseId = courseInfo.course_id;
      return dispatch("courseDetail/" + loadCourseDetailAction, courseId, {
        root: true
      }).then(() => {
        const chapters = rootGetters["courseDetail/" + courseDetailGetter](
          courseId
        );
        let firstDate = toDateObject(
          formResults.firstDate,
          formResults.firstDateTime
        );
        const reviewData = chapters.map((chapter: any) => {
          return chapter.classes
            .filter((data: any) => !data.eva)
            .map(() => {
              let dateTimeString;
              if (firstDate) {
                dateTimeString = formatLocalDateTime(firstDate);
                firstDate.setDate(firstDate.getDate() + 7);
              }
              return dateTimeString;
            });
        });
        return commit(updateReviewData, reviewData);
      });
    } else {
      return commit(
        updateReviewData,
        toLocalDateTimeString(formResults.firstDate, formResults.firstDateTime)
      );
    }
  },
  [submitReservationAction]: ({ commit, state, rootState, dispatch }) => {
    const courseInfo = state.courseInfo;
    const formResults = state.formResults;
    if (!formResults || !courseInfo) {
      return Promise.resolve();
    }
    const requestData: any = {
      studentInfo: {
        phoneNumber: formResults.phoneNumber,
        studentName: formResults.name
      },
      reservation: {
        course_id: courseInfo.course_id,
        firstDate: toDateISOString(
          formResults.firstDate,
          formResults.firstDateTime
        )
      } as Reservation
    };

    const oSearchParams = new URLSearchParams(window.location.search);
    const redeemCode = oSearchParams.get("redeemCode");
    if (redeemCode) {
      requestData.redeemCode = redeemCode;
    }

    if (rootState.user?.invitationCode) {
      requestData.invitationCode = rootState.user.invitationCode;
    }
    return HttpClient.post<StandRes<any>>("reservation", requestData)
      .then(({ data }) => {
        if (data && data.message) {
          if (
            !(rootState.user && rootState.user.std && rootState.user.std.length)
          ) {
            return dispatch("user/" + refreshTokenAction, null, {
              root: true
            }).then(() => Promise.resolve(data.message));
          }
          return Promise.resolve(data.message);
        }
        return Promise.resolve();
      })
      .then(res => {
        if (res) {
          return commit(updatePendingReservation, {
            reservation: res.reservation,
            prepayPackage: res.prepayPackage
          });
        }
      })
      .catch(() => {
        return Promise.resolve();
      });
  },
  [removePayFailReservationAction]: ({ commit, state }) => {
    if (state.reservationPending && state.reservationPending.reservation) {
      const reservationId = state.reservationPending.reservation._id;
      commit(updatePendingReservation, {});
      return HttpClient.delete(`reservation/${reservationId}`);
    }
  }
};
